import styles from "./switcher-child.module.css";

export default function SwitcherChild({
  icon,
  text,
  isActive,
  onClick,
}: {
  icon?: any;
  text: string;
  isActive?: boolean;
  onClick: () => void;
}) {
  return (
    <div
      className={`${isActive && styles.isActive} ${
        styles.switcherChildWrapper
      }`}
      onClick={onClick}
    >
      {icon}
      <span className={icon ? styles.descriptionText : styles.text}>
        {text}
      </span>
    </div>
  );
}
